import { api } from "./configs/axiosConfigs"

export const TypeProductAPI = {
    getTypeProducts: async (data:any) => {
        const response = await api.get(
            '/typeProduct', { params: {...data} }
        ).then(response => response.data)
        .catch((error) => {
            return error.response.data
        })
        return response
    },

    getTypeProductsByCompany: async (data:any) => {
        const response = await api.get(
            '/typeProduct/listByCompany', { params: {...data} }
        ).then(response => response.data)
        .catch((error) => {
            return error.response.data
        })
        return response
    },

    createTypeProduct: async (data: any) => {
        const response = await api.post(
            '/typeProduct/register', data
        ).then(response => response.data)
        .catch((error) => {
            console.error(error)
            return error.response.data
        })
        return response
    },
    
    editTypeProduct: async (idbranchoffice: number, data: any) => {
        const response = await api.patch(
            `/typeProduct/${idbranchoffice}`, data
        ).then(response => response.data)
        .catch((error) => {
            return error.response.data
        })
        return response
    },
    
    deleteTypeProduct: async (idbranchoffice: number) => {
        const response = await api.delete(
            `/typeProduct/${idbranchoffice}`
        ).then(response => response.data)
        .catch((error) => {
            return error.response.data
        })
        return response
    },
}